<template>
  <div>
    <div
      id="stepper-navigation"
      class="d-flex w-100 deepify-light-text text-center"
    >
      <div
        v-for="(step, index) in steps"
        :key="index"
        :class="{
          'deepify-text-success': steps[index].completed,
          'full-line': index < activeStep,
          'disabled': index > lastCompletedStep + 1,
          'active': index == activeStep,
        }"
        class="stepper-link cursor-pointer py-2"

        style="flex: 1"
        @click="activeStep = index; $emit('input', activeStep)"
      >
        {{ step.name }}
      </div>
    </div>
    <div
      v-if="showPrevButton || showNextButton"
      id="stepper-buttons"
      class="d-flex justify-content-between"
    >
      <div
        v-if="showPrevButton && activeStep > 0"
        class="py-2"
      >
        <button
          class="btn deepify-light-bg d-flex align-items-center"
          @click="$emit('input', --activeStep)"
        >
          <FontAwesome
            icon="fas fa-chevron-left"
            :size="28"
            class="mr-3"
          />
          BACK
          <span style="font-size:11px">
            &nbsp;&nbsp; - &nbsp;&nbsp;{{ steps[activeStep-1].name }}
          </span>
        </button>
      </div>
      <div
        v-if="showNextButton && activeStep < steps.length - 1"
        class="py-2"
      >
        <button
          class="btn deepify-light-bg d-flex align-items-center"
          :disabled="!steps[activeStep].completed"
          @click="$emit('input', ++activeStep)"
        >
          <span style="font-size:11px">
            {{ steps[activeStep+1].name }}&nbsp;&nbsp; - &nbsp;&nbsp;
          </span>
          NEXT
          <FontAwesome
            icon="fas fa-chevron-right"
            :size="28"
            class="ml-3"
          />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Stepper',
  props: {
    value: {
      type: Number,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
    showPrevButton: {
      type: Boolean,
      default: false,
    },
    showNextButton: {
      type: Boolean,
      default: false,
    },
    showDescriptions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeStep: 0,
    };
  },
  computed: {
    lastCompletedStep() {
      let lastIndex = -1;

      this.steps.forEach((step, index) => {
        if (step.completed) {
          lastIndex = index;
        }
      });

      return lastIndex;
    },
  },
  watch: {
    value(val) {
      this.activeStep = val;
    },
  },
  created() {
    this.activeStep = this.value;
  },
};
</script>
<style>
#stepper-navigation {
  background: #686868;
}

.stepper-link {
  transition: 0.3s ease all;
  font-size: 13px;
  position: relative;
}

.stepper-link::before {
  content: '';
  width: 0%;
  height: 3px;
  position: absolute;
  left: 0;
  bottom: -1.5px;
  background: #2aea77;
}

.stepper-link.active::before {
  width: 50%;
}

.stepper-link.active::after {
  content: '';
  width: 12px;
  height: 12px;
  position: absolute;
  left: calc(50% - 6px);
  bottom: -6px;
  border-radius: 50%;
  background: #2aea77;
}

.stepper-link.full-line::before {
  width: 100%;
}

.stepper-link.disabled {
  pointer-events: none;
  cursor: default;
}

.stepper-link.disabled::before {
  display: none;
}

.stepper-link:hover {
  background: rgba(255, 255, 255, 0.075);
}

#stepper-buttons {
  min-height: 58px;
}

button {
  text-align: initial;
}
</style>
